<!--begin::App-->
<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <!-- Persistent, unmissable, and compiled out of customer builds. Anyone who
       lands here from a link should know within a second that the data is fake. -->
  @if (demo.enabled && demo.showBanner) {
  <div class="demo-ribbon w-100 text-center py-2 px-4 fs-7 fw-semibold bg-primary text-inverse-primary"
       data-testid="demo-ribbon">
    ระบบสาธิต — ข้อมูลทั้งหมดเป็นตัวอย่าง ไม่ใช่ข้อมูลจริง
  </div>
  }
  <!--begin::Page-->
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    @if (appHeaderDisplay) {
    <app-header
      [ngClass]="appHeaderDefaultClass"
      id="kt_app_header"
      class="app-header bg-white border-bottom border-primary border-4"
      data-kt-sticky="true"
      data-kt-sticky-activate="{default: true, lg: true}"
      data-kt-sticky-name="app-header-minimize"
      data-kt-sticky-offset="{default: '200px', lg: '0'}"
      data-kt-sticky-animation="false"
    >
    </app-header>
    }

    <!--begin::Wrapper-->
    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
      @if (appSidebarDisplay) {
      <!--begin::sidebar-->
      <app-sidebar
        #ktSidebar
        id="kt_app_sidebar"
        class="app-sidebar flex-column"
        [ngClass]="appSidebarDefaultClass"
      >
      </app-sidebar>
      <!--end::sidebar-->
      } @if (appSidebarPanelDisplay) {
      <!-- TODO: app sidebar panel -->
      }
      <!--begin::Main-->
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">
          @if (appToolbarDisplay) {
          <app-toolbar
            class="app-toolbar"
            [ngClass]="appToolbarCSSClass"
            id="kt_app_toolbar"
            [appToolbarLayout]="appToolbarLayout"
          ></app-toolbar>
          }
          <app-content
            id=" kt_app_content"
            class="app-content pt-0"
            [ngClass]="contentCSSClasses"
            [contentContainerCSSClass]="contentContainerCSSClass"
            [appContentContiner]="appContentContiner"
            [appContentContainerClass]="appContentContainerClass"
          >
          </app-content>
        </div>
        <!--end::Content wrapper-->
        @if (appFooterDisplay && customer.footer?.length) {
        <app-customer-slots id="kt_app_footer" [slots]="customer.footer!"></app-customer-slots>
        } @else if (appFooterDisplay) {
        <app-footer
          class="app-footer"
          [ngClass]="appFooterCSSClass"
          id="kt_app_footer"
          [appFooterContainerCSSClass]="appFooterContainerCSSClass"
          displaySection="contact"
        ></app-footer>
        <!-- <app-footer
          class="app-footer bg-white"
          [ngClass]="appFooterCSSClass"
          id="kt_app_footer"
          [appFooterContainerCSSClass]="appFooterContainerCSSClass"
          displaySection="copyright"
        ></app-footer> -->
        }
      </div>
      <!--end:::Main-->
    </div>
    <!--end::Wrapper-->
  </div>
  <!--end::Page-->
</div>
<!--end::App-->

<app-scripts-init></app-scripts-init>
<ng-container>
  <app-scroll-top
    id="kt_scrolltop"
    class="scrolltop"
    data-kt-scrolltop="true"
  ></app-scroll-top>
</ng-container>
<!-- begin:: Drawers -->
<!-- <app-activity-drawer></app-activity-drawer>
<app-messenger-drawer></app-messenger-drawer> -->
<app-cart-drawer></app-cart-drawer>
<!-- end:: Drawers -->

<!-- end:: Engage -->
<!-- <app-engages></app-engages> -->
<!-- end:: Engage -->

<!-- begin:: Modals -->
<!-- <app-main-modal></app-main-modal>
<app-invite-users-modal></app-invite-users-modal> -->
<!-- end:: Modals -->
